import { MCP_APPROVALS_PATH, MCP_LOGIN_PATH } from '@app/constants/navigation';

import {
  MCP_TRANSACTION_PARAM,
  MCP_TRANSACTION_PATTERN,
  MCP_UUID_PATTERN,
} from '../constants';

const STORAGE_KEY = 'mcp-login-return';
const MAX_AGE_MS = 5 * 60 * 1000;
const CONSENT_PREFIX = `${MCP_LOGIN_PATH}?${MCP_TRANSACTION_PARAM}=`;
const APPROVAL_PREFIX = `${MCP_APPROVALS_PATH}/`;

const isMcpReturnPath = (path: string) =>
  (path.startsWith(CONSENT_PREFIX) &&
    MCP_TRANSACTION_PATTERN.test(path.slice(CONSENT_PREFIX.length))) ||
  (path.startsWith(APPROVAL_PREFIX) &&
    MCP_UUID_PATTERN.test(path.slice(APPROVAL_PREFIX.length)));

/** Only a short-lived navigation target, never a credential or arbitrary URL. */
export const rememberMcpLoginReturn = (path: string) => {
  if (!isMcpReturnPath(path)) return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ path, at: Date.now() }));
};

export const consumeMcpLoginReturn = (): string | null => {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  if (!stored) return null;
  try {
    const value: unknown = JSON.parse(stored);
    if (!value || typeof value !== 'object') return null;
    const { path, at } = value as Record<string, unknown>;
    if (
      typeof path !== 'string' ||
      typeof at !== 'number' ||
      !isMcpReturnPath(path) ||
      at > Date.now() ||
      Date.now() - at >= MAX_AGE_MS
    )
      return null;
    return path;
  } catch {
    return null;
  }
};
